


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbContainer, mdbRow, mdbCol, mdbTooltip, mdbBtn, mdbIcon } from '@folky-tools/mdbvue';
import clipperFixed from 'vuejs-clipper/src/components/clipper-fixed.vue';
import clipperUpload from 'vuejs-clipper/src/components/clipper-upload.vue';
import clipperRange from 'vuejs-clipper/src/components/clipper-range.vue';
import clipperPreview from 'vuejs-clipper/src/components/clipper-preview.vue';

@Component({
    components: {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbTooltip,
        mdbBtn,
        mdbIcon,
        clipperFixed,
        clipperUpload,
        clipperRange,
        clipperPreview
    }
})
export default class CropitImage extends Vue {
    @Prop({ required: true, type: String }) public src?: string;
    @Prop({ required: true, type: Number }) public ratio?: number;
    @Prop({ type: Boolean }) public changed?: boolean;
    @Prop({ required: true, type: String }) public uploadTitle?: string;
    @Prop({ required: true, type: String }) public preview?: string;
    @Prop({ required: true, type: Number }) public finalWidth?: number;
    @Prop({ required: true, type: Boolean }) public allowRotate: boolean = false;
    @Prop({ required: true, type: String }) public previousImage?: string;

    private zoomRate: number = 0.01;
    private minScale: number = 0.5;
    private rotate: number = 0;

    get imageSrc(): string {
        return this.src!;
    }

    set imageSrc(value: string) {
        this.$emit('update:src', value);
    }

    get imageChanged(): boolean {
        return this.changed!;
    }

    public getFinalImageFile(): File {
        const imageBase64: string = (this.$refs.clipper as any).clip({ wPixel: this.finalWidth }).toDataURL('image/jpg', 1).split(';')[1].split(',')[1];
        return this.imageBase64ToFile(imageBase64, 'image/jpg');
    }

    private imageBase64ToFile(b64Data: string, contentType: string, sliceSize: number = 512): File {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        return new File(byteArrays, 'temporary-image.jpg', { type: contentType });
    }
}
